// components/shared/info-field/info-field.ts
import { Component, Input, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { LeadsUpdateStatusModal } from '../leads-update-status-modal/leads-update-status-modal';
import { TrackClickDirective } from '../../../directives/track-click.directive';
import { runtimeLogger } from '../../../utils/runtime-logger.util';

// components/shared/info-field/info-field.ts
export interface InfoFieldItem {
  type: 'text' | 'image' | 'status' | 'new-simulation-button'; // ADICIONADO novo tipo
  title?: string;
  info?: string;
  imageUrl?: string;
  imageAlt?: string;
  status?: 'Pendente/Novo' | 'Em Negociação' | string;
  leadId?: number;
  cdSiglaTipo?: string;
  buttonText?: string; // ADICIONADO para texto do botão
  buttonAction?: () => void; // ADICIONADO para ação do botão
}

@Component({
  selector: 'app-info-field',
  standalone: true,
  imports: [CommonModule, TrackClickDirective],
  templateUrl: './info-field.html',
  styleUrls: ['./info-field.scss']
})
export class InfoField implements OnChanges {
  @Input() data: InfoFieldItem[] = [];
  @Input() columns: number = 3;

  constructor(private elementRef: ElementRef,
              private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['columns']) {
      const element = this.elementRef.nativeElement;
      element.style.setProperty('--columns', this.columns.toString());
    }
  }

  // MÉTODO CORRIGIDO: Mais flexível para diferentes formatos de texto
  getStatusBadgeClass(status: string): string {
    if (!status) return 'status-badge-default';

    const statusLower = status.toLowerCase().trim();

    if (statusLower.includes('pendente') || statusLower.includes('novo')) {
      return 'status-badge-yellow';
    } else if (statusLower.includes('negociação') || statusLower.includes('negociacao')) {
      return 'status-badge-green';
    } else {
      return 'status-badge-default';
    }
  }

  openChangeStatusLeadModal() : void {
    const leadId = this.data.find(i => i.type === 'status')?.leadId;
    const cdSiglaTipo = this.data.find(i => i.type === 'status')?.cdSiglaTipo;

    this.dialog.open(LeadsUpdateStatusModal, {
        width: 'auto',
        maxWidth: '95vw',
        panelClass: 'dialog-alterar-status',
        data: {
          idLead: leadId,
          cdSiglaTipo: cdSiglaTipo
        }
    });
  }

    handleButtonClick(item: InfoFieldItem): void {
    if (item.buttonAction) {
      item.buttonAction();
    } else {
      runtimeLogger.debug('Botão clicado:', item.buttonText || 'Gerar nova simulação');
      // Ação padrão se não houver buttonAction definida
    }
  }
}
